import IpaLogo from "./Logos/ipa-nowy-targ.webp";
import BochniakLogo from "./Logos/bochniak-logo.jpg";
import ZajazdLogo from "./Logos/zajazd_czorsztynski.jpg";
import ZnaczkiLogo from "./Logos/znaczki-logojpg.jpg";
import CzteryPory from "./Logos/logo-cztery.png";
import EkoLogo from "./Logos/logo-ekomuzeum.webp";
import CrosnaLogo from "./Logos/Crosna-spa-logo.jpg";


export const partners = [
    {
        logo: EkoLogo,
        link: "https://sprezyna.org/ekomuzeum-dziedziny-dunajca/histora-wspolpracy-co-to-jest-ekomuzeum",
        name: "Ekomuzeum Dziedziny Dunajca",
        alt: "Ekomuzeum dziedziny dunajca logo"
    },
    {
        logo: BochniakLogo,
        link: "https://ubochniaka.pl/",
        name: "U Bochniaka",
        alt: "U Bochniaka logo"
    },
    {
        logo: CzteryPory,
        link: "https://czorsztyn.czterypory.info/wynajem/",
        name: "Cztery pory roku",
        alt: "Cztery pory roku logo"
    },
    {
        logo: ZajazdLogo,
        link: "https://www.czorsztynski.pl/",
        name: "Zajazd Czorsztynski",
        alt: "Zajazd Czorsztynski logo"
    },
    {
        logo: ZnaczkiLogo,
        link: "https://www.znaczki-turystyczne.pl/",
        name: "Znaczki turystyczne",
        alt: "Znaczki turystyczne logo"
    },
    {
        logo: IpaLogo,
        link: "https://www.ipanowytarg.pl/",
        name: "IPA Nowy Targ",
        alt: "IPA Nowy Targ logo"
    },
    {
        logo: CrosnaLogo,
        link: "https://www.crosna.pl/",
        name: "Crosna Spa",
        alt: "Crosna Spa logo"
    },
];